import React, { useState, useEffect, useCallback } from "react";
import config from "../../Config";
import axios from "axios";
import SecurityMenu from "./SecurityMenu";
import Spinner from "react-bootstrap/Spinner";
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import RightsCheck from "../General/RightsCheck";

function RightsAssignment() {
  const params = useParams();
  const groupId = params.id;

  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [userGroup, setUserGroup] = useState({});
  const [loadingItem, setLoadingItem] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  const [controllerName, setControllerName] = useState("");
  const [functionName, setFunctionName] = useState("");
  const [fullURL, setFullURL] = useState("");
  const [hasRight, setHasRight] = useState("All");
  const [modulePrefix, setModulePrefix] = useState("");

  const [searchControllerName, setSearchControllerName] = useState("");
  const [searchFunctionName, setSearchFunctionName] = useState("");
  const [searchFullURL, setSearchFullURL] = useState("");
  const [searchHasRight, setSearchHasRight] = useState("All");

  const fetchGroup = useCallback(() => {
    return axios({
      method: "post",
      url: config.base_url + "Members/GetUserGroupByID",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        ID: groupId,
      },
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setUserGroup(response.data.UserGroup || {});
        }
      })
      .catch(function () {
        toast.error("Unable to load group details.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [AccessKey, UserID, MemberType, groupId]);

  const fetchPages = useCallback(() => {
    setLoading(true);

    return axios({
      method: "post",
      url: config.base_url + "Members/GetAllPagesByGroupID",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        ID: groupId,
        ControllerName: searchControllerName,
        FunctionName: searchFunctionName,
        FullURL: searchFullURL,
        HasRight: searchHasRight,
      },
    })
      .then(function (response) {
        setLedger(response.data.ListofRecords || []);
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Unable to load page rights.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [
    AccessKey,
    UserID,
    MemberType,
    groupId,
    searchControllerName,
    searchFunctionName,
    searchFullURL,
    searchHasRight,
  ]);

  useEffect(() => {
    document.title = "Group Rights Assignment";
    fetchGroup();
    fetchPages();
  }, [fetchGroup, fetchPages, reloadToken]);

  const handleSearch = (event) => {
    event.preventDefault();
    setSearchControllerName(controllerName.trim());
    setSearchFunctionName(functionName.trim());
    setSearchFullURL(fullURL.trim());
    setSearchHasRight(hasRight);
  };

  const handleStatusChange = (event) => {
    const value = event.target.value;
    setHasRight(value);
    setSearchHasRight(value);
  };

  const updateLocalRight = (pageId, checked) => {
    setLedger((prev) =>
      prev.map((item) =>
        item.ID === pageId ? { ...item, hasRights: checked } : item
      )
    );
  };

  const updateRights = (event, pageId) => {
    const checked = event.target.checked;
    const previousChecked = !checked;

    setLoadingItem(pageId);
    updateLocalRight(pageId, checked);

    axios({
      method: "post",
      url: config.base_url + "Members/UpdateGroupRight",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        ControllerID: pageId,
        GroupID: groupId,
        hasRights: checked,
      },
    })
      .then(function (response) {
        setLoadingItem(null);
        if (response.data.status_code == 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          updateLocalRight(pageId, previousChecked);
          toast.error(response.data.status_message || "Unable to update right.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function () {
        setLoadingItem(null);
        updateLocalRight(pageId, previousChecked);
        toast.error("Network error while updating right.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const bulkUpdate = ({ grant, useModule = false, controllerIds = [] }) => {
    if (!groupId) {
      return;
    }

    const payload = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      GroupID: parseInt(groupId, 10),
      hasRights: grant,
    };

    if (useModule) {
      if (!modulePrefix.trim()) {
        toast.error("Enter a module keyword first.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      payload.ModulePrefix = modulePrefix.trim();
    } else {
      if (!controllerIds.length) {
        toast.error("No pages selected for bulk update.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      payload.ControllerIDs = controllerIds;
    }

    setBulkLoading(true);

    axios({
      method: "post",
      url: config.base_url + "Members/BulkUpdateGroupRights",
      headers: { "Content-Type": "application/json" },
      data: payload,
    })
      .then(function (response) {
        setBulkLoading(false);
        if (response.data.status_code == 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setReloadToken((value) => value + 1);
        } else {
          toast.error(response.data.status_message || "Bulk update failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function () {
        setBulkLoading(false);
        toast.error("Network error during bulk update.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const grantAllShown = () => {
    bulkUpdate({
      grant: true,
      controllerIds: listOfLedger.map((item) => item.ID),
    });
  };

  const revokeAllShown = () => {
    bulkUpdate({
      grant: false,
      controllerIds: listOfLedger.map((item) => item.ID),
    });
  };

  const grantModule = () => {
    bulkUpdate({ grant: true, useModule: true });
  };

  const revokeModule = () => {
    bulkUpdate({ grant: false, useModule: true });
  };

  const grantedCount = listOfLedger.filter((item) => item.hasRights).length;

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={item.ID || index}>
          <td>{index + 1}</td>
          <td>{item.ID}</td>
          <td>{item.ControllerName}</td>
          <td>{item.FunctionName}</td>
          <td>{item.FullURL}</td>
          <td>{item.Details}</td>
          <td className="text-center">
            {loadingItem === item.ID ? (
              <Spinner animation="grow" size="sm" />
            ) : (
              <div className="form-check d-inline-block">
                <input
                  className="form-check-input"
                  checked={!!item.hasRights}
                  type="checkbox"
                  onChange={(e) => updateRights(e, item.ID)}
                />
              </div>
            )}
          </td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan="7">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <SecurityMenu />
      <ToastContainer />
      <RightsCheck />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Security/SecurityDashboard">Security</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Group Rights
                  </li>
                </ol>
              </nav>
              <div className="page-title">
                Rights Assignment for {userGroup.GroupName || `Group ${groupId}`}
              </div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/Security/GroupManagement"
                  className="button button-white button-icon"
                >
                  Manage Groups
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card mb-2">
            <div className="card-body">
              <Form onSubmit={handleSearch}>
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Controller</label>
                      <input
                        type="text"
                        className="form-control"
                        value={controllerName}
                        placeholder="Search controller"
                        onChange={(e) => setControllerName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Action</label>
                      <input
                        type="text"
                        className="form-control"
                        value={functionName}
                        placeholder="Search action"
                        onChange={(e) => setFunctionName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className="form-control"
                        value={fullURL}
                        placeholder="e.g. /support/ or Transport"
                        onChange={(e) => setFullURL(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Status</label>
                      <select
                        className="form-select"
                        value={hasRight}
                        onChange={handleStatusChange}
                      >
                        <option value="All">All</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <button
                      type="submit"
                      className="button button-primary w-100 mb-3"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>

          <div className="card mb-2">
            <div className="card-body">
              <div className="row align-items-end g-3">
                <div className="col-md-4">
                  <label className="form-label mb-1">Module / keyword bulk action</label>
                  <input
                    type="text"
                    className="form-control"
                    value={modulePrefix}
                    placeholder="e.g. Transport, Security, FeeSystem"
                    onChange={(e) => setModulePrefix(e.target.value)}
                  />
                  <div className="form-text">
                    Matches controller, action, URL, or details containing this text.
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="button button-primary"
                      disabled={bulkLoading || loading}
                      onClick={grantModule}
                    >
                      Grant Module
                    </button>
                    <button
                      type="button"
                      className="button button-white"
                      disabled={bulkLoading || loading}
                      onClick={revokeModule}
                    >
                      Revoke Module
                    </button>
                    <button
                      type="button"
                      className="button button-primary"
                      disabled={bulkLoading || loading || listOfLedger.length === 0}
                      onClick={grantAllShown}
                    >
                      Grant All Shown
                    </button>
                    <button
                      type="button"
                      className="button button-white"
                      disabled={bulkLoading || loading || listOfLedger.length === 0}
                      onClick={revokeAllShown}
                    >
                      Revoke All Shown
                    </button>
                    {bulkLoading && (
                      <span className="d-inline-flex align-items-center ms-2">
                        <Spinner animation="border" size="sm" />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                <div className="text-muted small">
                  Showing {listOfLedger.length} page(s)
                  {listOfLedger.length > 0 && (
                    <span>
                      {" "}
                      · {grantedCount} granted · {listOfLedger.length - grantedCount} not granted
                    </span>
                  )}
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>ID</th>
                      <th>Controller</th>
                      <th>Action</th>
                      <th>URL</th>
                      <th>Details</th>
                      <th className="text-center">Granted</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          <Spinner animation="border" role="status" />
                        </td>
                      </tr>
                    ) : (
                      renderLedger()
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RightsAssignment;
